/*
 * Copyright 2021 Larder Software Limited
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export const JIRA_COMPONENT_ANNOTATION = 'jira/component';
export const JIRA_BEARER_TOKEN_ANNOTATION = 'jira/token-type';
export const JIRA_PROJECT_KEY_ANNOTATION = 'jira/project-key';
export const JIRA_LABEL_ANNOTATION = 'jira/label';
export const JIRA_TEAM_ANNOTATION = 'jira/team';
export const DEFAULT_JIRA_QUERY_ANNOTATION = 'jira/all-issues-jql';
